// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3nZwQ","box":"WorkspacesBox_box__20_43","node":"WorkspacesBox_node__2iB8B"};